import { useNavigate, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PageSkeleton } from "@/components/PageSkeleton";
import { Shell } from "@/components/Shell";
import { SignIn } from "@/features/session/SignIn";
import { useMe } from "@/features/session/useMe";
import { Seizoenen } from "@/features/wedstrijden/Seizoenen";
import { keepScrollPosition } from "@jbnl/shared-ui";

export function SeizoenenPage() {
  const { t } = useTranslation(["paginas", "navigatie", "common"]);
  const { data: me, isPending } = useMe();
  const { seizoen: seizoenId, pagina } = useSearch({ from: "/seizoenen" });
  const navigate = useNavigate({ from: "/seizoenen" });

  if (isPending) {
    return (
      <Shell>
        <PageSkeleton />
      </Shell>
    );
  }

  if (!me) {
    return (
      <Shell>
        <SignIn />
      </Shell>
    );
  }

  // The API refuses this to anyone else regardless; hiding it here only avoids showing a
  // korpscontact a screen that would answer 403 to everything on it.
  if (!me.isBeheerder) {
    return (
      <Shell name={me.name} letterhead>
        <Card>
          <CardHeader>
            <CardTitle>{t("common:doors.noAccess")}</CardTitle>
            <CardDescription>
              {t("common:doors.noAccessDescription")}
            </CardDescription>
          </CardHeader>
        </Card>
      </Shell>
    );
  }

  return (
    <Shell name={me.name} wide>
      {/* The title above both panes rather than inside one: a card wrapped around the pair
          cannot contain a list that has to scroll inside its own frame. */}
      <header className="mb-6 space-y-1">
        <h1 className="text-2xl font-bold tracking-[-0.02em]">
          {t("navigatie:paginas.seizoenen.label")}
        </h1>
        <p className="text-sm text-muted-foreground">{t("seizoenen.uitleg")}</p>
      </header>

      <Seizoenen
        seizoenId={seizoenId}
        onKies={(id) =>
          void navigate({
            ...keepScrollPosition,
            search: (previous) => ({ ...previous, seizoen: id }),
          })
        }
        pagina={pagina}
        onPaginaChange={(next) =>
          void navigate({
            search: (previous) => ({ ...previous, pagina: next }),
            ...keepScrollPosition,
          })
        }
      />
    </Shell>
  );
}
